import mixpanel from 'mixpanel-browser';

import { mixpanelToken } from '@/config';
import commonEvents from '@/services/mixpanel/events/common';
import dashboardEvents from '@/services/mixpanel/events/dashboard';

class MixpanelEventsHandler {
    constructor() {
        if (!mixpanelToken) {
            throw new Error('Mixpanel token is required');
        }

        mixpanel.init(mixpanelToken);
    }

    get dashboard() {
        return dashboardEvents;
    }

    get common() {
        return commonEvents;
    }
}

export default MixpanelEventsHandler;
